export const CUSTOM_INDICATORS_STORAGE_KEYS = {
  EDITOR_INPUTS_PANEL_HEIGHT_PX:
    "vybe.customIndicatorEditor.inputsPanelHeightPx",
} as const;
